import { axiosInstance, axios } from '../utils/npm'
import { decrypt, handleUnauthorized } from '../utils/utils'

export const getIpoList = async data => {
  try {
    // const response = await axiosInstance.post(
    //   `/ipo/ipo_list?ipo_type=${data.ipo_type}&category=${data?.category}&page_size=${data?.page_size || 15}`
    // )
    const response = await axiosInstance.post(
      `/ipo/new-ipo-list?ipo_type=${data.ipo_type}&category=${data?.category}&page_size=${data?.page_size || 15}&search=${data?.search || ''}`
    )

    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getIpoDetail = async id => {
  try {
    const response = await axiosInstance.get(`/ipo/${id}/`)
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
    // return response
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getNewsList = async data => {
  try {
    const response = await axiosInstance.get(`/news/?page_size=${data?.page_size || 8}`)
    return response
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getNewspageWise = async url => {
  try {
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getNewspage = async (page, page_size) => {
  try {
    const response = await axiosInstance.get(
      `/news/?page=${page}&page_size=${page_size}`
    )
    return response
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getnewsDetails = async id => {
  try {
    const response = await axiosInstance.get(`/news/${id}/`)
    return response
  } catch (error) {
    console.error('Failed to fetch IPO list:', error)
    return error
  }
}

export const getIpoLiveDataPage = async (
  page,
  page_size,
  ipo_type,
  category,
  search
) => {
  // let ipo_type = ipo_type
  if (ipo_type === '' || ipo_type?.toLowerCase() === 'all ipos') {
    try {
      const response = await axiosInstance.post(
        `/ipo/new-ipo-list?category=${category}&page=${page}&page_size=${page_size}&search=${search}`
      )
      let res = decrypt(response)
      res = JSON.parse(res)
      return res
    } catch (error) {
      console.error('Failed to fetch IPO list:', error)
      return error
    }
  } else {
    try {
      const response = await axiosInstance.post(
        `/ipo/new-ipo-list?ipo_type=${ipo_type}&category=${category}&page=${page}&page_size=${page_size}&search=${search}`
      )
      let res = decrypt(response)
      res = JSON.parse(res)
      return res
    } catch (error) {
      console.error('Failed to fetch IPO list:', error)
      return error
    }
  }
}

export const getIpoLiveDataWise = async url => {
  try {
    const response = await axiosInstance.post(url)
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    return error
  }
}

export const addContactUs = async data => {
  try {
    const response = await axiosInstance.post('/contactus/', data)
    return response
  } catch (error) {
    return error
  }
}

export const faqListApi = async () => {
  try {
    const response = await axiosInstance.get(`/settings/create-list-faq/`)
    return response
  } catch (error) {
    return error
  }
}

// // --------------------- hemang code ----------------

// export const homePageIpoList = async data => {
//   try {
//     const response = await axiosInstance.get(
//       `ipo/list-of-ipo?platform=Web`
//     )
//     let res = decrypt(response)
//     res = JSON.parse(res)
//     return res
//   } catch (error) {
//     console.error('homePageIpoList :', error)
//     return error
//   }
// }


// --------------------- hemang code ----------------

// --------------------- hemang code ----------------

export const homePageIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/list-of-ipo?platform=Web`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const currentIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-ipo?platform=Web&year=${data?.year}&ipo_type=${data?.type}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const prospectusIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      // `ipo/year-wise-list-of-ipo?platform=Web&year=${data?.year}&ipo_type=${data?.type}`
      `ipo/year-wise-list-of-ipo-prospectus-document?platform=Web&year=${data?.year}&ipo_type=${data?.type}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const subscriptionIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-ipo-subscription?platform=Web&year=${data?.year}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const reviewIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-ipo-review?platform=Web&year=${data?.year}&ipo_type=${data?.type}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const performaceIpoList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-ipo-performance-tracker?platform=Web&year=${data?.year}&ipo_type=${data?.type}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const subscriptionDetails = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/ipo-subscription-detail/${data}/?platform=Web`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const allotmentList = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-ipo-allotment-document?platform=Web&year=${data?.year}${data?.type === 'all ipo' ? '' : `&ipo_type=${data?.type}`}`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const gmpDetails = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/ipo-gmp-detail/${data}/?platform=Web`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const alotnmentDetails = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/ipo-allotment-detail/${data}/?platform=Web`
    )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const calanderDetails = async data => {
  try {
    const response = await axiosInstance.get(
      `ipo/year-wise-list-of-upcoming-ipo?platform=Android&month=${data?.month}&year=${data?.year}&ipo_type=${data?.type}`
    )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const newsDetails = async data => {
  try {
    const response = await axiosInstance.get(
      `news/?page=${data?.page}&page_size=${data?.perPage}`
    )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

// demat-account/list-of-pan-number-with-allotment/<int:ipo_id>

export const demetAccountList = async data => {
  try {

    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.get(`/demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`, {
      headers: {
        Authorization: `Bearer ${token?.access}`
      }
    })
    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const addDemetAccount = async data => {
  try {
    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.post(`/demat-account/add-pan-number/`, data, {
      headers: {
        Authorization: `Bearer ${token?.access}`
      }
    })
    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const deleteDemetAccount = async id => {
  try {
    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.delete(`/demat-account/${id}/`, {
      headers: {
        Authorization: `Bearer ${token?.access}`
      }
    })
    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const editDemetAccount = async (data, user_id) => {
  try {

    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.put(`/demat-account/${user_id}/`, data, {
      headers: {
        Authorization: `Bearer ${token?.access}`
      }
    })
    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

// export const checkAllotmentDataList = async (data) => {
//   const token = JSON.parse(localStorage.getItem('login')) || '';

//   try {

//     const headers = {
//       Authorization: `Bearer ${token?.access}`,
//       'Content-Type': 'application/json',
//     };

//     const response = await axiosInstance.get(
//       `check-allotment/list-of-pan-card-with-allotment/${data?.id}/?platform=Web&page_size=${data?.perPage}&page=${data?.page}`,
//       { headers }
//     );

//     console.log('decrypt 1', response);

//     let res = decrypt(response?.data);

//     // If `meta` doesn't exist, decrypt and parse
//     console.log('decrypt', res);

//     // if (!res?.meta) {

//     // }
//     if (res?.meta?.status_code === 200) {
//       res = decrypt(response?.data);
//       res = JSON.parse(res);
//       return res;
//     } else {
//       console.warn('Non-200 response in meta:', res);
//       return res; // Or handle it however needed
//     }
//   } catch (error) {
//     console.error('checkAllotmentDataList Error:', error);
//     throw error;
//   }
// };


export const checkAllotmentDataList = async data => {
  try {

    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    // list-of-pan-number-with-allotment-web/<int:ipo_id>/</int:ipo_id>
    const response = await axiosInstance.get(`demat-account/list-of-pan-number-with-allotment-web/${data?.id}/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`, {
      headers: {
        Authorization: `Bearer ${token?.access}`,
        // 'Content-Type': 'application/json'
      }
    })
    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const addPanNumber = async data => {
  try {
    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.post(
      `check-allotment/add-pan-number/?platform=Web`,
      data, // <- This is the body (second parameter)
      {
        headers: {
          Authorization: `Bearer ${token?.access}`,
          // 'Content-Type': 'application/json' // Uncomment if needed
        }
      }
    )

    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = response
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const getAllotnment = async data => {
  try {
    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.post(
      `demat-account/recheck-allotment-status/${data?.id}/`,
      data, // <- This is the body (second parameter)
      {
        headers: {
          Authorization: `Bearer ${token?.access}`,
          // 'Content-Type': 'application/json' // Uncomment if needed
        }
      }
    )

    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    // let res = decrypt(response)
    // res = JSON.parse(res)
    return response
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}

export const slidebarData = async data => {
  try {
    const token = localStorage.getItem('login')
      ? JSON.parse(localStorage.getItem('login'))
      : ''

    const response = await axiosInstance.get(
      `ipo/banner-ipo-list?platform=web`,
      data, // <- This is the body (second parameter)
      {
        headers: {
          Authorization: `Bearer ${token?.access}`,
          // 'Content-Type': 'application/json' // Uncomment if needed
        }
      }
    )

    // const response = await axiosInstance.get(
    //   `demat-account/?platform=Web&page=${data?.page}&page_size=${data?.perPage}`
    // )
    let res = decrypt(response)
    res = JSON.parse(res)
    return res
  } catch (error) {
    console.error('homePageIpoList :', error)
    return error
  }
}
